import React from 'react';

import cn from 'classnames';

interface PaperProps {
  children: React.ReactNode;
  className?: string;
}

const Paper = ({ children, className }: PaperProps) => {
  return (
    <div
      className={cn(
        'bg-white-100 p-4 rounded-[16px] w-[322px] flex justify-center flex-col align-center shadow-lg',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Paper;
